export default __webpack_public_path__ + "static/media/zrak-postreh.6b158853.svg";